import type React from "react";
import { UserHistoryItem } from "./UserHistoryItem";
import { Calendar } from "lucide-react";

interface UserHistoryListProps {
  loading: boolean;
  filteredAndSortedUsers: any[];
  activePhone: string | null;
  conversationCounts?: { [phone: string]: number };
  onUserSelect: (user: any) => void;
  t: (key: string) => string;
  isDateFiltered?: boolean;
}

export const UserHistoryList: React.FC<UserHistoryListProps> = ({
  loading,
  filteredAndSortedUsers,
  activePhone,
  conversationCounts = {},
  onUserSelect,
  t,
  isDateFiltered = false,
}) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-24">
        <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mt-4" />
        <span className="p-4 mt-2 text-sm text-gray-500">
          {t("loading_users")}
        </span>
      </div>
    );
  }

  return (
    <div className="w-full px-2 mt-[1px] flex-1 min-h-0">
      <div className="h-full overflow-y-auto">
        {filteredAndSortedUsers.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full px-4">
            <Calendar className="w-12 h-12 text-gray-400 mb-3" />
            <h3 className="text-base font-medium text-gray-700 mb-1 text-center">
              {isDateFiltered ? t("no_messages_for_date") : t("no_users_found")}
            </h3>
            {isDateFiltered && (
              <p className="text-sm text-gray-500 text-center">
                {t("try_different_date")}
              </p>
            )}
          </div>
        ) : (
          <div className="space-y-1 pb-4">
            {filteredAndSortedUsers.map((user, idx) => {
              const chatCount = conversationCounts[user.phone] ?? 0;
              const isActive = activePhone === user.phone;

              return (
                <UserHistoryItem
                  key={`${user.id}-${idx}`}
                  user={user}
                  isActive={isActive}
                  chatCount={chatCount}
                  onUserSelect={onUserSelect}
                  t={t}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
